/** The part of a pagination item the visibility rule reads (MUI's `usePagination` items fit it). */
export interface PageItem {
  type: string
  page: number | null
}

/**
 * Hide the last page's number while a trailing ellipsis stands in for it, so a long
 * list reads `1 2 3 4 5 …` rather than `1 2 3 4 5 … 25`. The total stays unannounced;
 * the next arrow and the pages beside the current one still lead there.
 *
 * With no ellipsis (a short list, or the reader already near the end) every page is
 * contiguous, so the last number is the next step rather than a total, and stays.
 */
export function withoutFinalPage<T extends PageItem>(items: T[], count: number): T[] {
  const hasTrailingEllipsis = items.some(item => item.type === 'end-ellipsis')
  if (!hasTrailingEllipsis) return items

  return items.filter(item => !(item.type === 'page' && item.page === count))
}
